import { Box, Center, Spinner } from '@chakra-ui/react'
import { FC, useCallback, useContext, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { IDimension, IModel } from '../../../type/modelType'
import { uploadFileToStorage } from '../../../utils/modelEngine/uploadFile'

import { v4 as uuidv4 } from 'uuid'
import {
  getMeshGroups,
  mergeMeshesSettings,
  readGltf,
  saveModelConfig,
} from '../../../utils/modelEngine/configuration'
import { PageEnum } from '..'
import { AppContext } from '../../../libs/context'

interface IProps {
  setPage: (value: React.SetStateAction<PageEnum>) => void
}

const UploadPage: FC<IProps> = ({ setPage }) => {
  const [source, setSource] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [modelId, setModelId] = useState<string>(uuidv4())

  const context = useContext(AppContext)

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles[0]) {
      ;(async () => {
        setLoading(true)
        setSource(await uploadFileToStorage(acceptedFiles[0], modelId))
      })()
    }
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: '.glb,.zip',
  })

  useEffect(() => {
    if (source !== '') {
      readGltf(source).then(gltf => {
        const meshGroupFromFile = getMeshGroups(gltf)

        // setLoading(false)
        const model: IModel = {
          id: modelId,
          source,
          title: modelId,
          meshes: meshGroupFromFile,
        }

        saveModelConfig(model, context).then(() => {
          document.location.href = `/?p=${model.id}&landing=${PageEnum.ProductConfiguration}`
        })
      })
    }
  }, [source])

  return (
    <>
      {!loading ? (
        <Box
          {...getRootProps()}
          maxW="md"
          paddingInline="5"
          paddingBlock="100px"
          rounded="md"
          cursor="pointer"
          border="1px dashed rgb(136 136 136)"
          boxShadow="inset 0 0 10px 0 rgb(136 136 136 / 20%)"
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <Center>Drop the file here ...</Center>
          ) : (
            <Center>
              Drag 'n' drop a file here, or click to select a file
            </Center>
          )}
        </Box>
      ) : (
        <Spinner />
      )}
    </>
  )
}

export default UploadPage
